import styled from "styled-components";

export const MyFormClientRegister = styled.form`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  gap: 32px 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: "nome nome" "cpf cpf" "email email" "telefone telefone" "tipo tipo" "cep cep" "rua rua" "numero complemento" "bairro bairro" "uf cidade" "buttom buttom";

  > :nth-child(1) {
    grid-area: nome;
  }

  > :nth-child(2) {
    grid-area: cpf;
  }

  > :nth-child(3) {
    grid-area: email;
  }

  > :nth-child(4) {
    grid-area: telefone;
  }

  > :nth-child(5) {
    grid-area: tipo;
  }

  > :nth-child(6) {
    grid-area: cep;
  }

  > :nth-child(7) {
    grid-area: rua;
  }

  > :nth-child(8) {
    grid-area: numero;
  }

  > :nth-child(9) {
    grid-area: complemento;
  }

  > :nth-child(10) {
    grid-area: bairro;
  }

  > :nth-child(11) {
    grid-area: uf;
  }

  > :nth-child(12) {
    grid-area: cidade;
  }

  > :nth-child(13) {
    grid-area: buttom;

    > button {
      margin: auto;
    }
  }

  @media (min-width: 640px) {
    grid-template-columns: repeat(6, 1fr);
    grid-template-areas: "nome nome nome nome nome nome" "cpf cpf cpf email email email" "telefone telefone telefone tipo tipo tipo" "cep cep cep rua rua rua" "numero numero numero complemento complemento complemento" "bairro bairro uf uf cidade cidade" ". . buttom buttom . .";
  }
`;
